var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.5L25 2L21.8421 21L13.9459 15.5823L9.8421 19.7333V12.7667L1 11.5Z",
    fill: "#6E7484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 2L1 11.5L9.8421 12.7667M25 2L21.8421 21L9.8421 12.7667M25 2L9.8421 12.7667M9.8421 12.7667V19.7333L13.9459 15.5823",
    stroke: "#111B35",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.78dd58cc9e55936316e5689efa22ea9f.svg";
export { ForwardRef as ReactComponent };